const KeenSlider = window.KeenSlider

class ContentCarouselCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!KeenSlider || !this.els?.slides?.element) return null

    const slider = new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: true,
        mode: 'snap',
        slides: {
          perView: 1.75,
          spacing: 8,
        },
        breakpoints: {
          '(min-width: 900px)': {
            slides: {
              perView: 2.75,
              spacing: 8,
            },
          },
        },
        created: () => {
          this.els.slides.element.setAttribute('data-initialised', true)
        },
      },
    )

    this.setupArrowListeners(slider)

    return slider
  }
}

if (!customElements.get('content-carousel-carousel')) {
  customElements.define('content-carousel-carousel', ContentCarouselCarousel)
}
